import o from"./index.module.scss.js";const s=o;export{s as SelectTheme};
//# sourceMappingURL=index.js.map
